<script lang="ts">
	import type { Licence } from '$lib/features/licence/licence.type';
	import IconArrowTopRightThin from '~icons/mdi/arrow-top-right-thin';

	const {
		attribution,
		horizontalAlign = 'dropdown-end',
		openFrom = 'dropdown-right'
	}: {
		attribution: { author: string; sourceUrl: string; licence: Licence };
		horizontalAlign?: 'dropdown-start' | 'dropdown-center' | 'dropdown-end' | 'right';
		openFrom?: 'dropdown-top' | 'dropdown-bottom' | 'dropdown-right' | 'dropdown-left';
	} = $props();
</script>

<div class="dropdown dropdown-hover {horizontalAlign} {openFrom}">
	{@render Trigger()}
	<div class="menu dropdown-content mb-2 w-64 rounded-box bg-base-200/95 p-3 text-xs text-base-content" tabindex="-1">
		<div class="flex flex-col gap-1.5">
			{@render Content()}
		</div>
	</div>
</div>

{#snippet Trigger()}
	<div
		class="btn btn-circle bg-black/50 font-serif text-white italic btn-neutral btn-xs hover:bg-black/80"
		aria-label="Image Credits"
		role="button"
		tabindex="0"
	>
		i
	</div>
{/snippet}

{#snippet Content()}
	<div class="font-mono font-bold tracking-widest text-base-content/70">IMAGE CREDITS</div>

	<p class="mt-1 truncate font-medium text-base-content" title={`Uploaded by ${attribution.author}`}>
		AUTHOR: {attribution.author}
	</p>

	<div class="flex items-center gap-3 font-medium text-primary">
		<a class="flex link items-center gap-1 link-hover" href={attribution.sourceUrl} target="_blank" rel="noopener">
			SOURCE
			<IconArrowTopRightThin />
		</a>
		<a class="flex link items-center gap-1 link-hover" href={attribution.licence.link} target="_blank" rel="noopener">
			{attribution.licence.name}
			<IconArrowTopRightThin />
		</a>
	</div>
{/snippet}
